module.exports = __webpack_public_path__ + "img/estimatePicBatchUploadTips.e609e85d.jpg";